import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDownGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="down_green_svg__a"
      >
        <stop stopColor="#00DB4A" offset="0%" />
        <stop stopColor="#02B1B4" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        stroke="#FFF"
        fill="url(#down_green_svg__a)"
        cx={8}
        cy={8}
        r={7.5}
      />
      <path fill="#FFF" d="M5 6h6l-3 6z" />
    </g>
  </svg>
);
const Memo = memo(SvgDownGreen);
export default Memo;
